/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApplicationsRouteRouteImport } from './routes/applications/route'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as EventTypesRouteRouteImport } from './routes/event-types/route'
import { Route as HelpRouteRouteImport } from './routes/help/route'
import { Route as KitRouteImport } from './routes/kit'
import { Route as MessagesRouteRouteImport } from './routes/messages/route'
import { Route as PartialsRouteRouteImport } from './routes/partials/route'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as SuppressionsRouteImport } from './routes/suppressions'
import { Route as SystemRouteImport } from './routes/system'
import { Route as TemplatesRouteRouteImport } from './routes/templates/route'
import { Route as TimelinesRouteImport } from './routes/timelines'
import { Route as ApplicationsIndexRouteImport } from './routes/applications/index'
import { Route as ApplicationsAppIdRouteRouteImport } from './routes/applications/$appId/route'
import { Route as EventTypesIndexRouteImport } from './routes/event-types/index'
import { Route as EventTypesEventTypeIdRouteImport } from './routes/event-types/$eventTypeId'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as HelpSlugRouteImport } from './routes/help/$slug'
import { Route as HelpWhatsNewRouteImport } from './routes/help/whats-new'
import { Route as MessagesIndexRouteImport } from './routes/messages/index'
import { Route as MessagesMessageIdRouteImport } from './routes/messages/$messageId'
import { Route as PartialsIndexRouteImport } from './routes/partials/index'
import { Route as PartialsPartialIdRouteImport } from './routes/partials/$partialId'
import { Route as RequestsRequestIdRouteImport } from './routes/requests/$requestId'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesTemplateIdRouteRouteImport } from './routes/templates/$templateId/route'
import { Route as ApplicationsAppIdIndexRouteImport } from './routes/applications/$appId/index'
import { Route as ApplicationsAppIdEventTypesRouteImport } from './routes/applications/$appId/event-types'
import { Route as ApplicationsAppIdKeysRouteImport } from './routes/applications/$appId/keys'
import { Route as ApplicationsAppIdSendersRouteImport } from './routes/applications/$appId/senders'
import { Route as ApplicationsAppIdServiceBusRouteRouteImport } from './routes/applications/$appId/service-bus/route'
import { Route as ApplicationsAppIdSettingsRouteImport } from './routes/applications/$appId/settings'
import { Route as ApplicationsAppIdTemplatesRouteImport } from './routes/applications/$appId/templates'
import { Route as ApplicationsAppIdVariablesRouteImport } from './routes/applications/$appId/variables'
import { Route as ApplicationsAppIdWebhooksRouteImport } from './routes/applications/$appId/webhooks'
import { Route as TemplatesTemplateIdIndexRouteImport } from './routes/templates/$templateId/index'
import { Route as TemplatesTemplateIdVersionsRouteImport } from './routes/templates/$templateId/versions'
import { Route as ApplicationsAppIdServiceBusIndexRouteImport } from './routes/applications/$appId/service-bus/index'
import { Route as ApplicationsAppIdServiceBusSourceIdRouteImport } from './routes/applications/$appId/service-bus/$sourceId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsRouteRoute = ApplicationsRouteRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const EventTypesRouteRoute = EventTypesRouteRouteImport.update({
  id: '/event-types',
  path: '/event-types',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRouteRoute = HelpRouteRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRouteRoute = MessagesRouteRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const PartialsRouteRoute = PartialsRouteRouteImport.update({
  id: '/partials',
  path: '/partials',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppressionsRoute = SuppressionsRouteImport.update({
  id: '/suppressions',
  path: '/suppressions',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRouteRoute = TemplatesRouteRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelinesRoute = TimelinesRouteImport.update({
  id: '/timelines',
  path: '/timelines',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsIndexRoute = ApplicationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationsRouteRoute,
} as any)
const ApplicationsAppIdRouteRoute = ApplicationsAppIdRouteRouteImport.update({
  id: '/$appId',
  path: '/$appId',
  getParentRoute: () => ApplicationsRouteRoute,
} as any)
const EventTypesIndexRoute = EventTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventTypesRouteRoute,
} as any)
const EventTypesEventTypeIdRoute = EventTypesEventTypeIdRouteImport.update({
  id: '/$eventTypeId',
  path: '/$eventTypeId',
  getParentRoute: () => EventTypesRouteRoute,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpRouteRoute,
} as any)
const HelpSlugRoute = HelpSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => HelpRouteRoute,
} as any)
const HelpWhatsNewRoute = HelpWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => HelpRouteRoute,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MessagesRouteRoute,
} as any)
const MessagesMessageIdRoute = MessagesMessageIdRouteImport.update({
  id: '/$messageId',
  path: '/$messageId',
  getParentRoute: () => MessagesRouteRoute,
} as any)
const PartialsIndexRoute = PartialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartialsRouteRoute,
} as any)
const PartialsPartialIdRoute = PartialsPartialIdRouteImport.update({
  id: '/$partialId',
  path: '/$partialId',
  getParentRoute: () => PartialsRouteRoute,
} as any)
const RequestsRequestIdRoute = RequestsRequestIdRouteImport.update({
  id: '/requests/$requestId',
  path: '/requests/$requestId',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TemplatesRouteRoute,
} as any)
const TemplatesTemplateIdRouteRoute =
  TemplatesTemplateIdRouteRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => TemplatesRouteRoute,
  } as any)
const ApplicationsAppIdIndexRoute = ApplicationsAppIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationsAppIdRouteRoute,
} as any)
const ApplicationsAppIdEventTypesRoute =
  ApplicationsAppIdEventTypesRouteImport.update({
    id: '/event-types',
    path: '/event-types',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdKeysRoute = ApplicationsAppIdKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => ApplicationsAppIdRouteRoute,
} as any)
const ApplicationsAppIdSendersRoute =
  ApplicationsAppIdSendersRouteImport.update({
    id: '/senders',
    path: '/senders',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdServiceBusRouteRoute =
  ApplicationsAppIdServiceBusRouteRouteImport.update({
    id: '/service-bus',
    path: '/service-bus',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdSettingsRoute =
  ApplicationsAppIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdTemplatesRoute =
  ApplicationsAppIdTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdVariablesRoute =
  ApplicationsAppIdVariablesRouteImport.update({
    id: '/variables',
    path: '/variables',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const ApplicationsAppIdWebhooksRoute =
  ApplicationsAppIdWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => ApplicationsAppIdRouteRoute,
  } as any)
const TemplatesTemplateIdIndexRoute =
  TemplatesTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TemplatesTemplateIdRouteRoute,
  } as any)
const TemplatesTemplateIdVersionsRoute =
  TemplatesTemplateIdVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => TemplatesTemplateIdRouteRoute,
  } as any)
const ApplicationsAppIdServiceBusIndexRoute =
  ApplicationsAppIdServiceBusIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ApplicationsAppIdServiceBusRouteRoute,
  } as any)
const ApplicationsAppIdServiceBusSourceIdRoute =
  ApplicationsAppIdServiceBusSourceIdRouteImport.update({
    id: '/$sourceId',
    path: '/$sourceId',
    getParentRoute: () => ApplicationsAppIdServiceBusRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/applications': typeof ApplicationsRouteRouteWithChildren
  '/event-types': typeof EventTypesRouteRouteWithChildren
  '/help': typeof HelpRouteRouteWithChildren
  '/messages': typeof MessagesRouteRouteWithChildren
  '/partials': typeof PartialsRouteRouteWithChildren
  '/templates': typeof TemplatesRouteRouteWithChildren
  '/audit': typeof AuditRoute
  '/kit': typeof KitRoute
  '/review': typeof ReviewRoute
  '/suppressions': typeof SuppressionsRoute
  '/system': typeof SystemRoute
  '/timelines': typeof TimelinesRoute
  '/applications/$appId': typeof ApplicationsAppIdRouteRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRouteRouteWithChildren
  '/event-types/$eventTypeId': typeof EventTypesEventTypeIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/help/whats-new': typeof HelpWhatsNewRoute
  '/messages/$messageId': typeof MessagesMessageIdRoute
  '/partials/$partialId': typeof PartialsPartialIdRoute
  '/requests/$requestId': typeof RequestsRequestIdRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/event-types/': typeof EventTypesIndexRoute
  '/help/': typeof HelpIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/partials/': typeof PartialsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/applications/$appId/service-bus': typeof ApplicationsAppIdServiceBusRouteRouteWithChildren
  '/applications/$appId/event-types': typeof ApplicationsAppIdEventTypesRoute
  '/applications/$appId/keys': typeof ApplicationsAppIdKeysRoute
  '/applications/$appId/senders': typeof ApplicationsAppIdSendersRoute
  '/applications/$appId/settings': typeof ApplicationsAppIdSettingsRoute
  '/applications/$appId/templates': typeof ApplicationsAppIdTemplatesRoute
  '/applications/$appId/variables': typeof ApplicationsAppIdVariablesRoute
  '/applications/$appId/webhooks': typeof ApplicationsAppIdWebhooksRoute
  '/templates/$templateId/versions': typeof TemplatesTemplateIdVersionsRoute
  '/applications/$appId/': typeof ApplicationsAppIdIndexRoute
  '/templates/$templateId/': typeof TemplatesTemplateIdIndexRoute
  '/applications/$appId/service-bus/$sourceId': typeof ApplicationsAppIdServiceBusSourceIdRoute
  '/applications/$appId/service-bus/': typeof ApplicationsAppIdServiceBusIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/kit': typeof KitRoute
  '/review': typeof ReviewRoute
  '/suppressions': typeof SuppressionsRoute
  '/system': typeof SystemRoute
  '/timelines': typeof TimelinesRoute
  '/event-types/$eventTypeId': typeof EventTypesEventTypeIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/help/whats-new': typeof HelpWhatsNewRoute
  '/messages/$messageId': typeof MessagesMessageIdRoute
  '/partials/$partialId': typeof PartialsPartialIdRoute
  '/requests/$requestId': typeof RequestsRequestIdRoute
  '/applications': typeof ApplicationsIndexRoute
  '/event-types': typeof EventTypesIndexRoute
  '/help': typeof HelpIndexRoute
  '/messages': typeof MessagesIndexRoute
  '/partials': typeof PartialsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/applications/$appId/event-types': typeof ApplicationsAppIdEventTypesRoute
  '/applications/$appId/keys': typeof ApplicationsAppIdKeysRoute
  '/applications/$appId/senders': typeof ApplicationsAppIdSendersRoute
  '/applications/$appId/settings': typeof ApplicationsAppIdSettingsRoute
  '/applications/$appId/templates': typeof ApplicationsAppIdTemplatesRoute
  '/applications/$appId/variables': typeof ApplicationsAppIdVariablesRoute
  '/applications/$appId/webhooks': typeof ApplicationsAppIdWebhooksRoute
  '/templates/$templateId/versions': typeof TemplatesTemplateIdVersionsRoute
  '/applications/$appId': typeof ApplicationsAppIdIndexRoute
  '/templates/$templateId': typeof TemplatesTemplateIdIndexRoute
  '/applications/$appId/service-bus/$sourceId': typeof ApplicationsAppIdServiceBusSourceIdRoute
  '/applications/$appId/service-bus': typeof ApplicationsAppIdServiceBusIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/applications': typeof ApplicationsRouteRouteWithChildren
  '/event-types': typeof EventTypesRouteRouteWithChildren
  '/help': typeof HelpRouteRouteWithChildren
  '/messages': typeof MessagesRouteRouteWithChildren
  '/partials': typeof PartialsRouteRouteWithChildren
  '/templates': typeof TemplatesRouteRouteWithChildren
  '/audit': typeof AuditRoute
  '/kit': typeof KitRoute
  '/review': typeof ReviewRoute
  '/suppressions': typeof SuppressionsRoute
  '/system': typeof SystemRoute
  '/timelines': typeof TimelinesRoute
  '/applications/$appId': typeof ApplicationsAppIdRouteRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRouteRouteWithChildren
  '/event-types/$eventTypeId': typeof EventTypesEventTypeIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/help/whats-new': typeof HelpWhatsNewRoute
  '/messages/$messageId': typeof MessagesMessageIdRoute
  '/partials/$partialId': typeof PartialsPartialIdRoute
  '/requests/$requestId': typeof RequestsRequestIdRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/event-types/': typeof EventTypesIndexRoute
  '/help/': typeof HelpIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/partials/': typeof PartialsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/applications/$appId/service-bus': typeof ApplicationsAppIdServiceBusRouteRouteWithChildren
  '/applications/$appId/event-types': typeof ApplicationsAppIdEventTypesRoute
  '/applications/$appId/keys': typeof ApplicationsAppIdKeysRoute
  '/applications/$appId/senders': typeof ApplicationsAppIdSendersRoute
  '/applications/$appId/settings': typeof ApplicationsAppIdSettingsRoute
  '/applications/$appId/templates': typeof ApplicationsAppIdTemplatesRoute
  '/applications/$appId/variables': typeof ApplicationsAppIdVariablesRoute
  '/applications/$appId/webhooks': typeof ApplicationsAppIdWebhooksRoute
  '/templates/$templateId/versions': typeof TemplatesTemplateIdVersionsRoute
  '/applications/$appId/': typeof ApplicationsAppIdIndexRoute
  '/templates/$templateId/': typeof TemplatesTemplateIdIndexRoute
  '/applications/$appId/service-bus/$sourceId': typeof ApplicationsAppIdServiceBusSourceIdRoute
  '/applications/$appId/service-bus/': typeof ApplicationsAppIdServiceBusIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/applications'
    | '/event-types'
    | '/help'
    | '/messages'
    | '/partials'
    | '/templates'
    | '/audit'
    | '/kit'
    | '/review'
    | '/suppressions'
    | '/system'
    | '/timelines'
    | '/applications/$appId'
    | '/templates/$templateId'
    | '/event-types/$eventTypeId'
    | '/help/$slug'
    | '/help/whats-new'
    | '/messages/$messageId'
    | '/partials/$partialId'
    | '/requests/$requestId'
    | '/applications/'
    | '/event-types/'
    | '/help/'
    | '/messages/'
    | '/partials/'
    | '/templates/'
    | '/applications/$appId/service-bus'
    | '/applications/$appId/event-types'
    | '/applications/$appId/keys'
    | '/applications/$appId/senders'
    | '/applications/$appId/settings'
    | '/applications/$appId/templates'
    | '/applications/$appId/variables'
    | '/applications/$appId/webhooks'
    | '/templates/$templateId/versions'
    | '/applications/$appId/'
    | '/templates/$templateId/'
    | '/applications/$appId/service-bus/$sourceId'
    | '/applications/$appId/service-bus/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/kit'
    | '/review'
    | '/suppressions'
    | '/system'
    | '/timelines'
    | '/event-types/$eventTypeId'
    | '/help/$slug'
    | '/help/whats-new'
    | '/messages/$messageId'
    | '/partials/$partialId'
    | '/requests/$requestId'
    | '/applications'
    | '/event-types'
    | '/help'
    | '/messages'
    | '/partials'
    | '/templates'
    | '/applications/$appId/event-types'
    | '/applications/$appId/keys'
    | '/applications/$appId/senders'
    | '/applications/$appId/settings'
    | '/applications/$appId/templates'
    | '/applications/$appId/variables'
    | '/applications/$appId/webhooks'
    | '/templates/$templateId/versions'
    | '/applications/$appId'
    | '/templates/$templateId'
    | '/applications/$appId/service-bus/$sourceId'
    | '/applications/$appId/service-bus'
  id:
    | '__root__'
    | '/'
    | '/applications'
    | '/event-types'
    | '/help'
    | '/messages'
    | '/partials'
    | '/templates'
    | '/audit'
    | '/kit'
    | '/review'
    | '/suppressions'
    | '/system'
    | '/timelines'
    | '/applications/$appId'
    | '/templates/$templateId'
    | '/event-types/$eventTypeId'
    | '/help/$slug'
    | '/help/whats-new'
    | '/messages/$messageId'
    | '/partials/$partialId'
    | '/requests/$requestId'
    | '/applications/'
    | '/event-types/'
    | '/help/'
    | '/messages/'
    | '/partials/'
    | '/templates/'
    | '/applications/$appId/service-bus'
    | '/applications/$appId/event-types'
    | '/applications/$appId/keys'
    | '/applications/$appId/senders'
    | '/applications/$appId/settings'
    | '/applications/$appId/templates'
    | '/applications/$appId/variables'
    | '/applications/$appId/webhooks'
    | '/templates/$templateId/versions'
    | '/applications/$appId/'
    | '/templates/$templateId/'
    | '/applications/$appId/service-bus/$sourceId'
    | '/applications/$appId/service-bus/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApplicationsRouteRoute: typeof ApplicationsRouteRouteWithChildren
  EventTypesRouteRoute: typeof EventTypesRouteRouteWithChildren
  HelpRouteRoute: typeof HelpRouteRouteWithChildren
  MessagesRouteRoute: typeof MessagesRouteRouteWithChildren
  PartialsRouteRoute: typeof PartialsRouteRouteWithChildren
  TemplatesRouteRoute: typeof TemplatesRouteRouteWithChildren
  AuditRoute: typeof AuditRoute
  KitRoute: typeof KitRoute
  ReviewRoute: typeof ReviewRoute
  SuppressionsRoute: typeof SuppressionsRoute
  SystemRoute: typeof SystemRoute
  TimelinesRoute: typeof TimelinesRoute
  RequestsRequestIdRoute: typeof RequestsRequestIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications': {
      id: '/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof ApplicationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event-types': {
      id: '/event-types'
      path: '/event-types'
      fullPath: '/event-types'
      preLoaderRoute: typeof EventTypesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partials': {
      id: '/partials'
      path: '/partials'
      fullPath: '/partials'
      preLoaderRoute: typeof PartialsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppressions': {
      id: '/suppressions'
      path: '/suppressions'
      fullPath: '/suppressions'
      preLoaderRoute: typeof SuppressionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timelines': {
      id: '/timelines'
      path: '/timelines'
      fullPath: '/timelines'
      preLoaderRoute: typeof TimelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/': {
      id: '/applications/'
      path: '/'
      fullPath: '/applications/'
      preLoaderRoute: typeof ApplicationsIndexRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$appId': {
      id: '/applications/$appId'
      path: '/$appId'
      fullPath: '/applications/$appId'
      preLoaderRoute: typeof ApplicationsAppIdRouteRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/event-types/': {
      id: '/event-types/'
      path: '/'
      fullPath: '/event-types/'
      preLoaderRoute: typeof EventTypesIndexRouteImport
      parentRoute: typeof EventTypesRouteRoute
    }
    '/event-types/$eventTypeId': {
      id: '/event-types/$eventTypeId'
      path: '/$eventTypeId'
      fullPath: '/event-types/$eventTypeId'
      preLoaderRoute: typeof EventTypesEventTypeIdRouteImport
      parentRoute: typeof EventTypesRouteRoute
    }
    '/help/': {
      id: '/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof HelpRouteRoute
    }
    '/help/$slug': {
      id: '/help/$slug'
      path: '/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof HelpSlugRouteImport
      parentRoute: typeof HelpRouteRoute
    }
    '/help/whats-new': {
      id: '/help/whats-new'
      path: '/whats-new'
      fullPath: '/help/whats-new'
      preLoaderRoute: typeof HelpWhatsNewRouteImport
      parentRoute: typeof HelpRouteRoute
    }
    '/messages/': {
      id: '/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof MessagesRouteRoute
    }
    '/messages/$messageId': {
      id: '/messages/$messageId'
      path: '/$messageId'
      fullPath: '/messages/$messageId'
      preLoaderRoute: typeof MessagesMessageIdRouteImport
      parentRoute: typeof MessagesRouteRoute
    }
    '/partials/': {
      id: '/partials/'
      path: '/'
      fullPath: '/partials/'
      preLoaderRoute: typeof PartialsIndexRouteImport
      parentRoute: typeof PartialsRouteRoute
    }
    '/partials/$partialId': {
      id: '/partials/$partialId'
      path: '/$partialId'
      fullPath: '/partials/$partialId'
      preLoaderRoute: typeof PartialsPartialIdRouteImport
      parentRoute: typeof PartialsRouteRoute
    }
    '/requests/$requestId': {
      id: '/requests/$requestId'
      path: '/requests/$requestId'
      fullPath: '/requests/$requestId'
      preLoaderRoute: typeof RequestsRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof TemplatesRouteRoute
    }
    '/templates/$templateId': {
      id: '/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteRouteImport
      parentRoute: typeof TemplatesRouteRoute
    }
    '/applications/$appId/': {
      id: '/applications/$appId/'
      path: '/'
      fullPath: '/applications/$appId/'
      preLoaderRoute: typeof ApplicationsAppIdIndexRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/event-types': {
      id: '/applications/$appId/event-types'
      path: '/event-types'
      fullPath: '/applications/$appId/event-types'
      preLoaderRoute: typeof ApplicationsAppIdEventTypesRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/keys': {
      id: '/applications/$appId/keys'
      path: '/keys'
      fullPath: '/applications/$appId/keys'
      preLoaderRoute: typeof ApplicationsAppIdKeysRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/senders': {
      id: '/applications/$appId/senders'
      path: '/senders'
      fullPath: '/applications/$appId/senders'
      preLoaderRoute: typeof ApplicationsAppIdSendersRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/service-bus': {
      id: '/applications/$appId/service-bus'
      path: '/service-bus'
      fullPath: '/applications/$appId/service-bus'
      preLoaderRoute: typeof ApplicationsAppIdServiceBusRouteRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/settings': {
      id: '/applications/$appId/settings'
      path: '/settings'
      fullPath: '/applications/$appId/settings'
      preLoaderRoute: typeof ApplicationsAppIdSettingsRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/templates': {
      id: '/applications/$appId/templates'
      path: '/templates'
      fullPath: '/applications/$appId/templates'
      preLoaderRoute: typeof ApplicationsAppIdTemplatesRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/variables': {
      id: '/applications/$appId/variables'
      path: '/variables'
      fullPath: '/applications/$appId/variables'
      preLoaderRoute: typeof ApplicationsAppIdVariablesRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/applications/$appId/webhooks': {
      id: '/applications/$appId/webhooks'
      path: '/webhooks'
      fullPath: '/applications/$appId/webhooks'
      preLoaderRoute: typeof ApplicationsAppIdWebhooksRouteImport
      parentRoute: typeof ApplicationsAppIdRouteRoute
    }
    '/templates/$templateId/': {
      id: '/templates/$templateId/'
      path: '/'
      fullPath: '/templates/$templateId/'
      preLoaderRoute: typeof TemplatesTemplateIdIndexRouteImport
      parentRoute: typeof TemplatesTemplateIdRouteRoute
    }
    '/templates/$templateId/versions': {
      id: '/templates/$templateId/versions'
      path: '/versions'
      fullPath: '/templates/$templateId/versions'
      preLoaderRoute: typeof TemplatesTemplateIdVersionsRouteImport
      parentRoute: typeof TemplatesTemplateIdRouteRoute
    }
    '/applications/$appId/service-bus/': {
      id: '/applications/$appId/service-bus/'
      path: '/'
      fullPath: '/applications/$appId/service-bus/'
      preLoaderRoute: typeof ApplicationsAppIdServiceBusIndexRouteImport
      parentRoute: typeof ApplicationsAppIdServiceBusRouteRoute
    }
    '/applications/$appId/service-bus/$sourceId': {
      id: '/applications/$appId/service-bus/$sourceId'
      path: '/$sourceId'
      fullPath: '/applications/$appId/service-bus/$sourceId'
      preLoaderRoute: typeof ApplicationsAppIdServiceBusSourceIdRouteImport
      parentRoute: typeof ApplicationsAppIdServiceBusRouteRoute
    }
  }
}

interface ApplicationsAppIdServiceBusRouteRouteChildren {
  ApplicationsAppIdServiceBusSourceIdRoute: typeof ApplicationsAppIdServiceBusSourceIdRoute
  ApplicationsAppIdServiceBusIndexRoute: typeof ApplicationsAppIdServiceBusIndexRoute
}

const ApplicationsAppIdServiceBusRouteRouteChildren: ApplicationsAppIdServiceBusRouteRouteChildren =
  {
    ApplicationsAppIdServiceBusSourceIdRoute:
      ApplicationsAppIdServiceBusSourceIdRoute,
    ApplicationsAppIdServiceBusIndexRoute:
      ApplicationsAppIdServiceBusIndexRoute,
  }

const ApplicationsAppIdServiceBusRouteRouteWithChildren =
  ApplicationsAppIdServiceBusRouteRoute._addFileChildren(
    ApplicationsAppIdServiceBusRouteRouteChildren,
  )

interface ApplicationsAppIdRouteRouteChildren {
  ApplicationsAppIdServiceBusRouteRoute: typeof ApplicationsAppIdServiceBusRouteRouteWithChildren
  ApplicationsAppIdEventTypesRoute: typeof ApplicationsAppIdEventTypesRoute
  ApplicationsAppIdKeysRoute: typeof ApplicationsAppIdKeysRoute
  ApplicationsAppIdSendersRoute: typeof ApplicationsAppIdSendersRoute
  ApplicationsAppIdSettingsRoute: typeof ApplicationsAppIdSettingsRoute
  ApplicationsAppIdTemplatesRoute: typeof ApplicationsAppIdTemplatesRoute
  ApplicationsAppIdVariablesRoute: typeof ApplicationsAppIdVariablesRoute
  ApplicationsAppIdWebhooksRoute: typeof ApplicationsAppIdWebhooksRoute
  ApplicationsAppIdIndexRoute: typeof ApplicationsAppIdIndexRoute
}

const ApplicationsAppIdRouteRouteChildren: ApplicationsAppIdRouteRouteChildren =
  {
    ApplicationsAppIdServiceBusRouteRoute:
      ApplicationsAppIdServiceBusRouteRouteWithChildren,
    ApplicationsAppIdEventTypesRoute: ApplicationsAppIdEventTypesRoute,
    ApplicationsAppIdKeysRoute: ApplicationsAppIdKeysRoute,
    ApplicationsAppIdSendersRoute: ApplicationsAppIdSendersRoute,
    ApplicationsAppIdSettingsRoute: ApplicationsAppIdSettingsRoute,
    ApplicationsAppIdTemplatesRoute: ApplicationsAppIdTemplatesRoute,
    ApplicationsAppIdVariablesRoute: ApplicationsAppIdVariablesRoute,
    ApplicationsAppIdWebhooksRoute: ApplicationsAppIdWebhooksRoute,
    ApplicationsAppIdIndexRoute: ApplicationsAppIdIndexRoute,
  }

const ApplicationsAppIdRouteRouteWithChildren =
  ApplicationsAppIdRouteRoute._addFileChildren(
    ApplicationsAppIdRouteRouteChildren,
  )

interface ApplicationsRouteRouteChildren {
  ApplicationsAppIdRouteRoute: typeof ApplicationsAppIdRouteRouteWithChildren
  ApplicationsIndexRoute: typeof ApplicationsIndexRoute
}

const ApplicationsRouteRouteChildren: ApplicationsRouteRouteChildren = {
  ApplicationsAppIdRouteRoute: ApplicationsAppIdRouteRouteWithChildren,
  ApplicationsIndexRoute: ApplicationsIndexRoute,
}

const ApplicationsRouteRouteWithChildren =
  ApplicationsRouteRoute._addFileChildren(ApplicationsRouteRouteChildren)

interface EventTypesRouteRouteChildren {
  EventTypesEventTypeIdRoute: typeof EventTypesEventTypeIdRoute
  EventTypesIndexRoute: typeof EventTypesIndexRoute
}

const EventTypesRouteRouteChildren: EventTypesRouteRouteChildren = {
  EventTypesEventTypeIdRoute: EventTypesEventTypeIdRoute,
  EventTypesIndexRoute: EventTypesIndexRoute,
}

const EventTypesRouteRouteWithChildren = EventTypesRouteRoute._addFileChildren(
  EventTypesRouteRouteChildren,
)

interface HelpRouteRouteChildren {
  HelpSlugRoute: typeof HelpSlugRoute
  HelpWhatsNewRoute: typeof HelpWhatsNewRoute
  HelpIndexRoute: typeof HelpIndexRoute
}

const HelpRouteRouteChildren: HelpRouteRouteChildren = {
  HelpSlugRoute: HelpSlugRoute,
  HelpWhatsNewRoute: HelpWhatsNewRoute,
  HelpIndexRoute: HelpIndexRoute,
}

const HelpRouteRouteWithChildren = HelpRouteRoute._addFileChildren(
  HelpRouteRouteChildren,
)

interface MessagesRouteRouteChildren {
  MessagesMessageIdRoute: typeof MessagesMessageIdRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
}

const MessagesRouteRouteChildren: MessagesRouteRouteChildren = {
  MessagesMessageIdRoute: MessagesMessageIdRoute,
  MessagesIndexRoute: MessagesIndexRoute,
}

const MessagesRouteRouteWithChildren = MessagesRouteRoute._addFileChildren(
  MessagesRouteRouteChildren,
)

interface PartialsRouteRouteChildren {
  PartialsPartialIdRoute: typeof PartialsPartialIdRoute
  PartialsIndexRoute: typeof PartialsIndexRoute
}

const PartialsRouteRouteChildren: PartialsRouteRouteChildren = {
  PartialsPartialIdRoute: PartialsPartialIdRoute,
  PartialsIndexRoute: PartialsIndexRoute,
}

const PartialsRouteRouteWithChildren = PartialsRouteRoute._addFileChildren(
  PartialsRouteRouteChildren,
)

interface TemplatesTemplateIdRouteRouteChildren {
  TemplatesTemplateIdVersionsRoute: typeof TemplatesTemplateIdVersionsRoute
  TemplatesTemplateIdIndexRoute: typeof TemplatesTemplateIdIndexRoute
}

const TemplatesTemplateIdRouteRouteChildren: TemplatesTemplateIdRouteRouteChildren =
  {
    TemplatesTemplateIdVersionsRoute: TemplatesTemplateIdVersionsRoute,
    TemplatesTemplateIdIndexRoute: TemplatesTemplateIdIndexRoute,
  }

const TemplatesTemplateIdRouteRouteWithChildren =
  TemplatesTemplateIdRouteRoute._addFileChildren(
    TemplatesTemplateIdRouteRouteChildren,
  )

interface TemplatesRouteRouteChildren {
  TemplatesTemplateIdRouteRoute: typeof TemplatesTemplateIdRouteRouteWithChildren
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

const TemplatesRouteRouteChildren: TemplatesRouteRouteChildren = {
  TemplatesTemplateIdRouteRoute: TemplatesTemplateIdRouteRouteWithChildren,
  TemplatesIndexRoute: TemplatesIndexRoute,
}

const TemplatesRouteRouteWithChildren = TemplatesRouteRoute._addFileChildren(
  TemplatesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApplicationsRouteRoute: ApplicationsRouteRouteWithChildren,
  EventTypesRouteRoute: EventTypesRouteRouteWithChildren,
  HelpRouteRoute: HelpRouteRouteWithChildren,
  MessagesRouteRoute: MessagesRouteRouteWithChildren,
  PartialsRouteRoute: PartialsRouteRouteWithChildren,
  TemplatesRouteRoute: TemplatesRouteRouteWithChildren,
  AuditRoute: AuditRoute,
  KitRoute: KitRoute,
  ReviewRoute: ReviewRoute,
  SuppressionsRoute: SuppressionsRoute,
  SystemRoute: SystemRoute,
  TimelinesRoute: TimelinesRoute,
  RequestsRequestIdRoute: RequestsRequestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
